module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_easy_social_media_sharing.png";